import React from 'react';

// Feb 2026 — Master FABTEXS AI brand lockup. This is the single source of
// truth for the FABTEXS AI logo across the entire application. Two variants:
//   • variant="full" (default) — full wordmark for headers, login, sidebar,
//     landing/pricing/legal pages.
//   • variant="mark" — square A+i mark only, for very compact areas like
//     favicons, mobile navs, or badge-sized brand marks.
// The image assets live at /assets/brand/. Never inline the logo as text —
// the wordmark uses a bespoke typeface that would be lost.
const FULL_SRC = '/assets/brand/fabtexs-ai-logo.png';
const MARK_SRC = '/assets/brand/fabtexs-ai-mark.png';

export default function BrandLogo({
  variant = 'full',
  className = '',
  height,
  ariaLabel = 'FABTEXS AI',
}) {
  const src = variant === 'mark' ? MARK_SRC : FULL_SRC;
  const style = height ? { height: typeof height === 'number' ? `${height}px` : height, width: 'auto' } : undefined;
  return (
    <img
      src={src}
      alt={ariaLabel}
      className={`select-none ${className}`}
      style={style}
      draggable={false}
      loading="eager"
      data-testid={`brand-logo-${variant}`}
    />
  );
}
